export default {
  en: {
    "Сегмент не найден": "Segment not found",
    "Все сегменты": "All segments",
    "Сеть недоступна. Попробуйте ещё раз.": "Network unavailable. Please try again.",
    "Ссылка недействительна или устарела. Запросите новую.": "The link is invalid or has expired. Request a new one.",
    "Неверный пароль.": "Wrong password.",
    "Слишком много попыток. Подождите минуту.": "Too many attempts. Wait a minute.",
    "Проверьте поля формы.": "Please check the form fields.",
    "Потеряли якорь?": "Lost your anchor?",
    "Пришлём ссылку для нового пароля. Она действует 60 минут и срабатывает один раз.": "We will send a link to set a new password. It is valid for 60 minutes and works once.",
    "Если аккаунт с адресом {email} существует, письмо уже в пути.": "If an account with the address {email} exists, the email is already on its way.",
    "Вернуться ко входу": "Back to sign in",
    "Отправляем…": "Sending…",
    "Прислать ссылку": "Send link",
    "Я вспомнил пароль": "I remembered my password",
    "Пароли не совпадают": "Passwords do not match",
    "Новый пароль": "New password",
    "После смены пароля все остальные сессии будут завершены.": "After changing the password, all other sessions will be ended.",
    "Пароль изменён. Подтвердите вход вторым фактором.": "Password changed. Confirm sign-in with your second factor.",
    "В ссылке нет токена.": "The link has no token.",
    "Запросить новую ссылку": "Request a new link",
    "Минимум 10 символов": "At least 10 characters",
    "Повторите пароль": "Repeat password",
    "Сохраняем…": "Saving…",
    "Сохранить и войти": "Save and sign in",
    "В ссылке нет токена приглашения.": "The link has no invitation token.",
    "Приглашение не найдено": "Invitation not found",
    "Ко входу": "To sign in",
    "Проверяем приглашение…": "Checking the invitation…",
    "Добро пожаловать в «{ws}»": "Welcome to \"{ws}\"",
    "{who} приглашает": "{who} invites",
    "Команда": "Team",
    "с ролью «{role}».": "with the role \"{role}\".",
    "У вас уже есть аккаунт MailOcean — подтвердите паролем.": "You already have a MailOcean account — confirm with your password.",
    "Ваше имя": "Your name",
    "Пароль": "Password",
    "Придумайте пароль": "Choose a password",
    "Ныряем…": "Diving…",
    "Присоединиться": "Join",
    "Забыли пароль?": "Forgot password?",
    "владелец": "owner",
    "администратор": "admin",
    "разработчик": "developer",
    "наблюдатель": "viewer",
    "Адрес добавлен в подавления": "The address was added to suppressions",
    "Жёсткий отскок": "Hard bounce",
    "Жалоба на спам": "Spam complaint",
    "Отписка": "Unsubscribe",
    "Вручную": "Manual",
    "Ящик переполнен 3 раза за 30 дней": "Mailbox full 3 times in 30 days",
    "{email}: {reason}. Повторная отправка может ухудшить репутацию домена. Удалить всё равно?": "{email}: {reason}. Sending again may hurt the domain’s reputation. Delete anyway?",
    "Удалить {email}?": "Delete {email}?",
    "Подавления": "Suppressions",
    "Адреса, на которые мы не отправляем. Отскоки и жалобы блокируют все письма, отписка — только маркетинговые: сброс пароля дойдёт.": "Addresses we do not send to. Bounces and complaints block all emails; unsubscribes block only marketing emails, so password resets still arrive.",
    "Только маркетинг": "Marketing only",
    "Все письма": "All emails",
    "Добавить": "Add",
    "Поиск по адресу": "Search by address",
    "Список чист": "The list is clean",
    "Сюда автоматически попадают адреса с жёсткими отскоками и жалобами.": "Addresses with hard bounces and complaints end up here automatically.",
    "Адрес": "Address",
    "Область": "Scope",
    "Причина": "Reason",
    "Источник": "Source",
    "Когда": "When",
    "все письма": "all emails",
    "маркетинг": "marketing",
    "Удалить": "Delete",
    "Сохранено": "Saved",
    "Настройки": "Settings",
    "Рабочее пространство, внешний вид и доступ.": "Workspace, appearance and access.",
    "Рабочее пространство": "Workspace",
    "Название": "Name",
    "Сайт": "Website",
    "ID:": "ID:",
    "Сохранить": "Save",
    "Внешний вид": "Appearance",
    "Как в системе": "System default",
    "Профиль": "Profile",
    "Имя:": "Name:",
    "Роль:": "Role:",
    "Политика безопасности": "Security policy",
    "Теперь 2FA обязателен для всех": "2FA is now required for everyone",
    "Требование 2FA снято": "2FA requirement removed",
    "Сначала включите 2FA себе в разделе «Безопасность»": "First turn on 2FA for yourself in the Security section",
    "Требовать двухфакторный вход от всех участников": "Require two-factor sign-in from all members",
    "Участники без 2FA увидят только страницу настройки, пока не включат его. Меняет только владелец.": "Members without 2FA will see only the setup page until they enable it. Only the owner can change this.",
    "Сценарии": "Journeys",
    "Частотный лимит маркетинга сценариев": "Frequency cap for journey marketing",
    "Не больше N писем сценариев одному контакту за период; сценарий может только ужесточить": "No more than N journey emails to one contact per period; a journey can only tighten this",
    "Писем": "Emails",
    "писем за": "emails per",
    "Дней": "Days",
    "дн.": "d.",
    "Часовой пояс пространства": "Workspace time zone",
    "Для контактов без своего пояса: тихие часы, «до 10:00 по времени контакта», триггеры по дате": "For contacts without their own time zone: quiet hours, \"until 10:00 contact time\", date triggers",
    "Онбординг": "Onboarding",
    "Пройдено шагов: {done} из {total}.": "Steps completed: {done} of {total}.",
    "Открыть мастер погружения": "Open the Deep dive wizard",
    "Настройку пространства проводят владелец или администратор.": "The workspace is set up by an owner or administrator.",
    "Отправка": "Sending",
    "Провайдер:": "Provider:",
    " — песочница: письма проходят весь путь, но не покидают MailOcean.": " — sandbox: emails go through the full path but never leave MailOcean.",
    "Владелец": "Owner",
    "Администратор": "Admin",
    "Разработчик": "Developer",
    "Наблюдатель": "Watcher",
    "Всё, включая назначение владельцев": "Everything, including assigning owners",
    "Команда, домены, настройки": "Team, domains, settings",
    "Ключи, домены, вебхуки, шаблоны": "Keys, domains, webhooks, templates",
    "Только чтение": "Read only",
    "Кто работает в «{name}». Каждый входит своим аккаунтом — так журнал действий остаётся честным.": "Who works in \"{name}\". Everyone signs in with their own account, so the activity log stays honest.",
    "Пригласить": "Invite",
    "Приглашение отправлено на {email}": "Invitation sent to {email}",
    "Участники": "Members",
    "Имя": "Name",
    "Роль": "Role",
    "С нами": "With us since",
    "· это вы": "· this is you",
    "вкл": "on",
    "нет": "no",
    "Удалить {name} из пространства? Сессии будут завершены.": "Remove {name} from the workspace? Their sessions will be ended.",
    "Роль изменена": "Role changed",
    "Участник удалён": "Member removed",
    "Ждут ответа": "Awaiting reply",
    "отправлено {sent} · истекает {exp}": "sent {sent} · expires {exp}",
    "Приглашение отозвано": "Invitation revoked",
    "Отозвать": "Revoke",
    "Пригласить в команду": "Invite to the team",
    "Отмена": "Cancel",
    "Отправить приглашение": "Send invitation",
    "Ссылка действует 7 дней. Владельцами становятся только через смену роли владельцем.": "The link is valid for 7 days. Owners are appointed only when an owner changes a role.",
    "Тестовое событие поставлено в очередь": "Test event queued",
    "ожидает": "pending",
    "отправляется": "sending",
    "доставлен": "delivered",
    "ошибка": "error",
    "Вебхуки": "Webhooks",
    "События о письмах в ваш сервер: доставка, отскоки, жалобы. Подпись:": "Email events sent to your server: delivery, bounces, complaints. Signature:",
    "Новый эндпоинт": "New endpoint",
    "Секрет подписи для {url}": "Signing secret for {url}",
    "Секрет показывается один раз. Повторы: до 8 попыток с экспоненциальной паузой.": "The secret is shown once. Retries: up to 8 attempts with exponential backoff.",
    "Готово": "Done",
    "Эндпоинтов пока нет": "No endpoints yet",
    "Подключите эндпоинт, чтобы бэкенд узнавал об отскоках и жалобах в реальном времени.": "Connect an endpoint so your backend learns about bounces and complaints in real time.",
    "формат {format}": "format {format}",
    "Событий: {n} · создан {when}": "Events: {n} · created {when}",
    "Доставки": "Deliveries",
    "Доставок пока нет": "No deliveries yet",
    "Отправьте письмо или нажмите Ping.": "Send an email or click Ping.",
    "Событие": "Event",
    "Состояние": "Status",
    "Попыток": "Attempts",
    "Ответ": "Reply",
    "Создать": "Create",
    "Только https и публичный адрес; редиректы не выполняются": "HTTPS and a public address only; redirects are not followed",
    "События": "Events",
    "Формат": "Format",
    "Переезжаете с SendGrid или Postmark? Выберите их формат — ваш обработчик событий заработает без изменений.": "Moving from SendGrid or Postmark? Pick their format and your event handler will work without changes.",
    "Удалить вебхук {url}?": "Delete webhook {url}?",
    "Сохраните коды в менеджере паролей. Каждый работает один раз и показывается только сейчас.": "Save the codes in a password manager. Each works once and is shown only now.",
    "Скопировать коды": "Copy codes",
    "MailOcean — коды восстановления": "MailOcean — recovery codes",
    "Скачать .txt": "Download .txt",
    "Я сохранил коды": "I saved the codes",
    "Passkey добавлен 🔑": "Passkey added 🔑",
    "Вход отпечатком, лицом или PIN устройства — без пароля и кода. Защищает от фишинга: ключ работает только на этом сайте.": "Sign in with fingerprint, face or device PIN — no password or code. Protects against phishing: the key works only on this site.",
    "добавлен {when}": "added {when}",
    "вход {when}": "signed in {when}",
    "ещё не использовался": "not used yet",
    "Удалить passkey «{name}»?": "Delete passkey \"{name}\"?",
    "Пока ни одного passkey.": "No passkeys yet.",
    "Название, например «MacBook»": "Name, e.g. \"MacBook\"",
    "Ждём устройство…": "Waiting for the device…",
    "Добавить passkey": "Add passkey",
    "Пространство «{name}» требует второй фактор. Включите приложение-аутентификатор или добавьте passkey — после этого откроются остальные разделы.": "The workspace \"{name}\" requires a second factor. Turn on an authenticator app or add a passkey, and the other sections will open.",
    "Безопасность": "Security",
    "Двухфакторный вход защищает ключи, домены и команду, даже если пароль утёк.": "Two-factor sign-in protects keys, domains and the team, even if a password leaks.",
    "Приложение-аутентификатор (TOTP)": "Authenticator app (TOTP)",
    "Google Authenticator, 1Password, Bitwarden, Яндекс Ключ — любое приложение с кодами на 30 секунд.": "Google Authenticator, 1Password, Bitwarden, Yandex Key — any app that shows 30-second codes.",
    "включён": "on",
    "выключен": "off",
    "Включён {when}. Осталось кодов восстановления:": "Enabled {when}. Recovery codes left:",
    " — пора выпустить новые.": " — time to generate new ones.",
    "Код из приложения или код восстановления": "Code from the app or a recovery code",
    "Новые коды восстановления": "New recovery codes",
    "Выключить": "Turn off",
    "Выключить двухфакторный вход? Аккаунт останется защищён только паролем.": "Turn off two-factor sign-in? The account will be protected by password only.",
    "Двухфакторный вход выключен": "Two-factor sign-in turned off",
    "Включить двухфакторный вход": "Turn on two-factor sign-in",
    "QR-код для приложения-аутентификатора": "QR code for the authenticator app",
    "1. Отсканируйте QR-код в приложении. Не получается — введите ключ вручную:": "1. Scan the QR code in the app. If that does not work, enter the key manually:",
    "2. Введите шесть цифр из приложения": "2. Enter the six digits from the app",
    "Подтвердить и включить": "Confirm and turn on",
    "Двухфакторный вход включён 🛡": "Two-factor sign-in turned on 🛡",
    "Сессии и устройства": "Sessions and devices",
    "Завершить все сессии, кроме этой? На других устройствах придётся войти заново.": "End all sessions except this one? You will need to sign in again on other devices.",
    "Выйти на других устройствах": "Sign out on other devices",
    "Завершено сессий: {n}": "Sessions ended: {n}",
    "Сессия завершена": "Session ended",
    "Мобильное приложение": "Mobile app",
    "Браузер": "Browser",
    "это устройство": "this device",
    "приложение": "app",
    "браузер": "browser",
    "· вход {when}": "· signed in {when}",
    "· активность {when}": "· active {when}",
    "Завершить": "End",
    "Push-уведомления получают:": "Push notifications go to:",
    "Шаблоны": "Templates",
    "Письма, которые код отправляет по алиасу с переменными. Каждое сохранение — новая версия; отправленное письмо помнит свою.": "Emails your code sends by alias with variables. Each save creates a new version; a sent email keeps its own.",
    "Новый шаблон": "New template",
    "Алиас": "Alias",
    "Тема": "Subject",
    "Переменные": "Variables",
    "Версия": "Version",
    "Изменён": "Updated",
    "Шаблонов пока нет": "No templates yet",
    "Создать шаблон": "Create template",
    "Вынесите вёрстку чеков и кодов из кода: разработчик передаёт только алиас и переменные.": "Move receipt and code layouts out of your code: the developer passes only the alias and variables.",
    "Шаблон создан": "Template created",
    "Сохранено как версия {v}": "Saved as version {v}",
    "Такой алиас уже занят": "This alias is already taken",
    "Удалить шаблон? Отправка по этому алиасу начнёт возвращать 404.": "Delete the template? Sending by this alias will start returning 404.",
    "Все шаблоны": "All templates",
    "Переменные:": "Variables:",
    "экранируются,": "are escaped,",
    "вставляются как есть,": "are inserted as is,",
    "вложенные поля.": "nested fields.",
    "Сохранить версию": "Save version",
    "Его передаёт код": "Your code passes it",
    "Текстовая версия": "Text version",
    "Для почтовых клиентов без HTML и для фильтров спама": "For email clients without HTML and for spam filters",
    "Предпросмотр": "Preview",
    "Текст": "Text",
    "Тема:": "Subject:",
    "Предпросмотр письма": "Email preview",
    "Нет HTML-версии": "No HTML version",
    "Нет текстовой версии": "No text version",
    "Не хватает переменных:": "Missing variables:",
    "API вернёт 422, а не отправит пустоту.": "the API will return 422 instead of sending an empty value.",
    "Тестовые переменные": "Test variables",
    "Заполнить по шаблону": "Fill from template",
    "Некорректный JSON": "Invalid JSON",
    "Отправка из кода": "Sending from code",
    "Появятся после сохранения": "Will appear after saving",
    "Версии": "Versions",
    "Сегменты": "Segments",
    "Сохранённые условия: атрибуты, согласие, события за период. Список получателей всегда считается заново — сегмент не «замораживает» людей.": "Saved conditions: attributes, consent, events over a period. The recipient list is always recalculated, so a segment does not \"freeze\" people.",
    "Новый сегмент": "New segment",
    "Сегментов пока нет": "No segments yet",
    "Например: «тариф pro и оплатил за 30 дней» или «есть согласие и не открывал приложение 60 дней».": "For example: \"plan pro and paid within 30 days\" or \"has consent and has not opened the app for 60 days\".",
    "Сегмент": "Segment",
    "Размер": "Size",
    "Ревизия": "Revision",
    "посчитано {when}": "counted {when}",
    "ещё не пересчитывался": "not recalculated yet",
    "JSON не разбирается": "JSON does not parse",
    "Сегмент сохранён": "Segment saved",
    "Удалить сегмент «{name}»?": "Delete segment \"{name}\"?",
    "Это дерево сложнее конструктора (not, фильтры свойств, часы) — правьте его в JSON.": "This tree is more complex than the builder (not, attribute filters, hours), so edit it in JSON.",
    "Ревизия {rev} · ключ": "Revision {rev} · key",
    "Покупатели за 30 дней": "Buyers in the last 30 days",
    "Ключ": "Key",
    "латиница, цифры, - и _": "latin letters, digits, - and _",
    "Конструктор": "Builder",
    "Условия в JSON": "Conditions in JSON",
    "Посчитать": "Count",
    "Кто получит маркетинг": "Who will get marketing",
    "Нажмите «Посчитать»: покажем, сколько контактов подходит и сколько отсеется до отправки — без согласия, отозвавших, подавленных, без адреса.": "Click \"Count\": we will show how many contacts match and how many are filtered out before sending: no consent, withdrawn, suppressed, or no address.",
    "получат маркетинг": "will get marketing",
    "из {total}": "of {total}",
    "Подходят под условия": "Match the conditions",
    "без адреса": "no address",
    "в подавлениях": "suppressed",
    "отозвали согласие": "withdrew consent",
    "без согласия": "no consent",
    "Например:": "For example:",
    "Сегмент может ссылаться на другой сегмент — только на один уровень. Условия проверяются по схеме атрибутов: оператор должен подходить к типу.": "A segment can reference another segment, one level only. Conditions are checked against the attribute schema: the operator must fit the type.",
    "без согласия {n}": "no consent {n}",
    "отозвали {n}": "withdrew {n}",
    "подавлены {n}": "suppressed {n}",
    "без адреса {n}": "no address {n}",
    "Из {total}{details} → получат маркетинг {eligible}.": "Of {total}{details} → will get marketing {eligible}.",
    "все условия": "all conditions",
    "любое условие": "any condition",
    "Удалить группу": "Delete group",
    "Пока ни одного условия.": "No conditions yet.",
    "и": "and",
    "или": "or",
    "Условие": "Condition",
    "Группа": "Group",
    "Удалить условие": "Delete condition",
    "Оператор": "Operator",
    "Значение": "Value",
    "дней": "days",
    "от, до": "from, to",
    "через запятую": "comma-separated",
    "значение": "value",
    "Вид условия": "Condition type",
    "Атрибут": "Attribute",
    "Поле": "Field",
    "Статус согласия": "Consent status",
    "есть согласие на маркетинг": "has marketing consent",
    "согласие отозвано": "consent withdrawn",
    "записи о согласии нет": "no consent record",
    "Имя события": "Event name",
    "Сравнение количества": "Count comparison",
    "не менее": "at least",
    "не более": "at most",
    "ровно": "exactly",
    "Сколько раз": "How many times",
    "раз за": "times in",
    "всё": "all",
    "Согласие": "Consent",
    "равно": "equals",
    "не равно": "not equal",
    "одно из": "one of",
    "ни одно из": "none of",
    "больше": "greater than",
    "не меньше": "at least",
    "меньше": "less than",
    "не больше": "at most",
    "между": "between",
    "содержит": "contains",
    "начинается с": "starts with",
    "заполнено": "filled",
    "не заполнено": "not filled",
    "за последние N дней": "within the last N days",
    "больше N дней назад": "more than N days ago",
    "в ближайшие N дней": "within the next N days",
    "да": "yes",
    "Часовой пояс": "Time zone",
    "Локаль": "Locale",
    "Дата добавления": "Added on",
    "Статус": "Status",
    "Политика": "Policy",
    "Уведомления": "Notifications",
    "Каждое уведомление — каскад по каналам. «Принято каналом», «Доставлено», «Прочитано» и «Цель» — разные сигналы.": "Each notification is a cascade across channels. \"Accepted by channel\", \"Delivered\", \"Read\" and \"Goal\" are different signals.",
    "Обновить": "Refresh",
    "Тестовая отправка": "Test send",
    "все": "all",
    "все каналы": "all channels",
    "Канал": "Channel",
    "все политики": "all policies",
    "Период": "Period",
    "тег: kind=order": "tag: kind=order",
    "Тег (ключ=значение)": "Tag (key=value)",
    "Уведомлений нет": "No notifications",
    "Отправьте первое через": "Send the first one via",
    "или «Тестовую отправку».": "or a \"Test send\".",
    "Каскад": "Cascade",
    "Стоимость": "Cost",
    "код": "code",
    "оценка": "estimate",
    "Показать ещё": "Show more",
    "Уведомление не найдено": "Notification not found",
    "Возможно, оно другого пространства или данные удалены по сроку хранения.": "It may belong to another workspace, or the data was deleted after the retention period.",
    "Погружение уведомления": "Notification deep dive",
    "политика": "policy",
    "код подтверждения": "verification code",
    "сервисное": "service",
    "контакт": "contact",
    "Отменить": "Cancel",
    "Отменить уведомление? Шаги, ещё не переданные поставщику, отменятся; уже переданные не отзываются.": "Cancel the notification? Steps not yet handed to the provider will be cancelled; those already handed over cannot be recalled.",
    "Отменено шагов: {n}": "Steps cancelled: {n}",
    "; уже у поставщика: {k}": "; already with the provider: {k}",
    "Все уведомления": "All notifications",
    "по данным поставщика": "per provider data",
    "часть — оценка": "partly an estimate",
    "Худший случай": "Worst case",
    "потолок {max}": "cap {max}",
    "без потолка": "no cap",
    "Шагов": "Steps",
    "успех на шаге {n}": "succeeded at step {n}",
    "сейчас шаг {n}": "now at step {n}",
    "Длительность": "Duration",
    "завершено {when}": "finished {when}",
    "идёт": "running",
    "Теги:": "Tags:",
    "всё время": "all time",
    "24 часа": "24 hours",
    "7 дней": "7 days",
    "30 дней": "30 days",
    "☀️ Мелководье": "☀️ Shallows",
    "🌑 Глубина": "🌑 Deep",
  },
  uk: {
    "Сегмент не найден": "Сегмент не знайдено",
    "Все сегменты": "Усі сегменти",
    "Сеть недоступна. Попробуйте ещё раз.": "Мережа недоступна. Спробуйте ще раз.",
    "Ссылка недействительна или устарела. Запросите новую.": "Посилання недійсне або застаріло. Запросіть нове.",
    "Неверный пароль.": "Невірний пароль.",
    "Слишком много попыток. Подождите минуту.": "Забагато спроб. Зачекайте хвилину.",
    "Проверьте поля формы.": "Перевірте поля форми.",
    "Потеряли якорь?": "Загубили якір?",
    "Пришлём ссылку для нового пароля. Она действует 60 минут и срабатывает один раз.": "Надішлемо посилання для нового пароля. Воно діє 60 хвилин і спрацьовує один раз.",
    "Если аккаунт с адресом {email} существует, письмо уже в пути.": "Якщо акаунт з адресою {email} існує, лист уже в дорозі.",
    "Вернуться ко входу": "Повернутися до входу",
    "Отправляем…": "Надсилаємо…",
    "Прислать ссылку": "Надіслати посилання",
    "Я вспомнил пароль": "Я згадав пароль",
    "Пароли не совпадают": "Паролі не збігаються",
    "Новый пароль": "Новий пароль",
    "После смены пароля все остальные сессии будут завершены.": "Після зміни пароля всі інші сеанси буде завершено.",
    "Пароль изменён. Подтвердите вход вторым фактором.": "Пароль змінено. Підтвердьте вхід другим фактором.",
    "В ссылке нет токена.": "У посиланні немає токена.",
    "Запросить новую ссылку": "Запросити нове посилання",
    "Минимум 10 символов": "Щонайменше 10 символів",
    "Повторите пароль": "Повторіть пароль",
    "Сохраняем…": "Зберігаємо…",
    "Сохранить и войти": "Зберегти і увійти",
    "В ссылке нет токена приглашения.": "У посиланні немає токена запрошення.",
    "Приглашение не найдено": "Запрошення не знайдено",
    "Ко входу": "До входу",
    "Проверяем приглашение…": "Перевіряємо запрошення…",
    "Добро пожаловать в «{ws}»": "Ласкаво просимо до «{ws}»",
    "{who} приглашает": "{who} запрошує",
    "Команда": "Команда",
    "с ролью «{role}».": "з роллю «{role}».",
    "У вас уже есть аккаунт MailOcean — подтвердите паролем.": "У вас уже є акаунт MailOcean — підтвердіть паролем.",
    "Ваше имя": "Ваше ім’я",
    "Пароль": "Пароль",
    "Придумайте пароль": "Придумайте пароль",
    "Ныряем…": "Занурюємося…",
    "Присоединиться": "Приєднатися",
    "Забыли пароль?": "Забули пароль?",
    "владелец": "власник",
    "администратор": "адміністратор",
    "разработчик": "розробник",
    "наблюдатель": "спостерігач",
    "Адрес добавлен в подавления": "Адресу додано до списку придушення",
    "Жёсткий отскок": "Жорсткий відскок",
    "Жалоба на спам": "Скарга на спам",
    "Отписка": "Відписка",
    "Вручную": "Вручну",
    "Ящик переполнен 3 раза за 30 дней": "Поштову скриньку переповнено 3 рази за 30 днів",
    "{email}: {reason}. Повторная отправка может ухудшить репутацию домена. Удалить всё равно?": "{email}: {reason}. Повторне надсилання може погіршити репутацію домену. Видалити все одно?",
    "Удалить {email}?": "Видалити {email}?",
    "Подавления": "Придушення",
    "Адреса, на которые мы не отправляем. Отскоки и жалобы блокируют все письма, отписка — только маркетинговые: сброс пароля дойдёт.": "Адреси, на які ми не надсилаємо. Відскоки і скарги блокують усі листи, відписка — лише маркетингові: скидання пароля дійде.",
    "Только маркетинг": "Лише маркетинг",
    "Все письма": "Усі листи",
    "Добавить": "Додати",
    "Поиск по адресу": "Пошук за адресою",
    "Список чист": "Список порожній",
    "Сюда автоматически попадают адреса с жёсткими отскоками и жалобами.": "Сюди автоматично потрапляють адреси з жорсткими відскоками та скаргами.",
    "Адрес": "Адреса",
    "Область": "Область",
    "Причина": "Причина",
    "Источник": "Джерело",
    "Когда": "Коли",
    "все письма": "усі листи",
    "маркетинг": "маркетинг",
    "Удалить": "Видалити",
    "Сохранено": "Збережено",
    "Настройки": "Налаштування",
    "Рабочее пространство, внешний вид и доступ.": "Простір, зовнішній вигляд і доступ.",
    "Рабочее пространство": "Простір",
    "Название": "Назва",
    "Сайт": "Сайт",
    "ID:": "ID:",
    "Сохранить": "Зберегти",
    "Внешний вид": "Зовнішній вигляд",
    "Как в системе": "Як у системі",
    "Профиль": "Профіль",
    "Имя:": "Ім’я:",
    "Роль:": "Роль:",
    "Политика безопасности": "Політика безпеки",
    "Теперь 2FA обязателен для всех": "2FA тепер обов’язкова для всіх",
    "Требование 2FA снято": "Вимогу 2FA знято",
    "Сначала включите 2FA себе в разделе «Безопасность»": "Спочатку увімкніть 2FA для себе в розділі «Безпека»",
    "Требовать двухфакторный вход от всех участников": "Вимагати двофакторний вхід від усіх учасників",
    "Участники без 2FA увидят только страницу настройки, пока не включат его. Меняет только владелец.": "Учасники без 2FA бачитимуть лише сторінку налаштування, доки не увімкнуть її. Змінює лише власник.",
    "Сценарии": "Сценарії",
    "Частотный лимит маркетинга сценариев": "Частотний ліміт маркетингу сценаріїв",
    "Не больше N писем сценариев одному контакту за период; сценарий может только ужесточить": "Не більше N листів сценаріїв одному контакту за період; сценарій може лише посилити обмеження",
    "Писем": "Листів",
    "писем за": "листів за",
    "Дней": "Днів",
    "дн.": "дн.",
    "Часовой пояс пространства": "Часовий пояс простору",
    "Для контактов без своего пояса: тихие часы, «до 10:00 по времени контакта», триггеры по дате": "Для контактів без власного поясу: тихі години, «до 10:00 за часом контакту», тригери за датою",
    "Онбординг": "Онбординг",
    "Пройдено шагов: {done} из {total}.": "Пройдено кроків: {done} з {total}.",
    "Открыть мастер погружения": "Відкрити майстер «Занурення»",
    "Настройку пространства проводят владелец или администратор.": "Налаштування простору виконують власник або адміністратор.",
    "Отправка": "Надсилання",
    "Провайдер:": "Провайдер:",
    " — песочница: письма проходят весь путь, но не покидают MailOcean.": " — пісочниця: листи проходять весь шлях, але не виходять за межі MailOcean.",
    "Владелец": "Власник",
    "Администратор": "Адміністратор",
    "Разработчик": "Розробник",
    "Наблюдатель": "Спостерігач",
    "Всё, включая назначение владельцев": "Усе, зокрема призначення власників",
    "Команда, домены, настройки": "Команда, домени, налаштування",
    "Ключи, домены, вебхуки, шаблоны": "Ключі, домени, вебхуки, шаблони",
    "Только чтение": "Лише читання",
    "Кто работает в «{name}». Каждый входит своим аккаунтом — так журнал действий остаётся честным.": "Хто працює в «{name}». Кожен входить зі свого акаунта — так журнал дій лишається чесним.",
    "Пригласить": "Запросити",
    "Приглашение отправлено на {email}": "Запрошення надіслано на {email}",
    "Участники": "Учасники",
    "Имя": "Ім’я",
    "Роль": "Роль",
    "С нами": "З нами",
    "· это вы": "· це ви",
    "вкл": "увімк.",
    "нет": "ні",
    "Удалить {name} из пространства? Сессии будут завершены.": "Видалити {name} з простору? Сеанси буде завершено.",
    "Роль изменена": "Роль змінено",
    "Участник удалён": "Учасника видалено",
    "Ждут ответа": "Очікують відповіді",
    "отправлено {sent} · истекает {exp}": "надіслано {sent} · спливає {exp}",
    "Приглашение отозвано": "Запрошення відкликано",
    "Отозвать": "Відкликати",
    "Пригласить в команду": "Запросити до команди",
    "Отмена": "Скасувати",
    "Отправить приглашение": "Надіслати запрошення",
    "Ссылка действует 7 дней. Владельцами становятся только через смену роли владельцем.": "Посилання діє 7 днів. Власниками стають лише через зміну ролі власником.",
    "Тестовое событие поставлено в очередь": "Тестову подію поставлено в чергу",
    "ожидает": "очікує",
    "отправляется": "надсилається",
    "доставлен": "доставлено",
    "ошибка": "помилка",
    "Вебхуки": "Вебхуки",
    "События о письмах в ваш сервер: доставка, отскоки, жалобы. Подпись:": "Події про листи на ваш сервер: доставка, відскоки, скарги. Підпис:",
    "Новый эндпоинт": "Новий ендпоїнт",
    "Секрет подписи для {url}": "Секрет підпису для {url}",
    "Секрет показывается один раз. Повторы: до 8 попыток с экспоненциальной паузой.": "Секрет показується один раз. Повтори: до 8 спроб з експоненційною паузою.",
    "Готово": "Готово",
    "Эндпоинтов пока нет": "Ендпоїнтів ще немає",
    "Подключите эндпоинт, чтобы бэкенд узнавал об отскоках и жалобах в реальном времени.": "Підключіть ендпоїнт, щоб ваш бекенд дізнавався про відскоки та скарги в реальному часі.",
    "формат {format}": "формат {format}",
    "Событий: {n} · создан {when}": "Подій: {n} · створено {when}",
    "Доставки": "Доставки",
    "Доставок пока нет": "Доставок ще немає",
    "Отправьте письмо или нажмите Ping.": "Надішліть лист або натисніть Ping.",
    "Событие": "Подія",
    "Состояние": "Стан",
    "Попыток": "Спроб",
    "Ответ": "Відповідь",
    "Создать": "Створити",
    "Только https и публичный адрес; редиректы не выполняются": "Лише https і публічна адреса; редиректи не виконуються",
    "События": "Події",
    "Формат": "Формат",
    "Переезжаете с SendGrid или Postmark? Выберите их формат — ваш обработчик событий заработает без изменений.": "Переходите з SendGrid або Postmark? Оберіть їхній формат — ваш обробник подій працюватиме без змін.",
    "Удалить вебхук {url}?": "Видалити вебхук {url}?",
    "Сохраните коды в менеджере паролей. Каждый работает один раз и показывается только сейчас.": "Збережіть коди в менеджері паролів. Кожен працює один раз і показується лише зараз.",
    "Скопировать коды": "Скопіювати коди",
    "MailOcean — коды восстановления": "MailOcean — коди відновлення",
    "Скачать .txt": "Завантажити .txt",
    "Я сохранил коды": "Я зберіг коди",
    "Passkey добавлен 🔑": "Passkey додано 🔑",
    "Вход отпечатком, лицом или PIN устройства — без пароля и кода. Защищает от фишинга: ключ работает только на этом сайте.": "Вхід відбитком пальця, обличчям або PIN-кодом пристрою — без пароля й коду. Захищає від фішингу: ключ працює лише на цьому сайті.",
    "добавлен {when}": "додано {when}",
    "вход {when}": "вхід {when}",
    "ещё не использовался": "ще не використовувався",
    "Удалить passkey «{name}»?": "Видалити passkey «{name}»?",
    "Пока ни одного passkey.": "Passkey ще немає.",
    "Название, например «MacBook»": "Назва, наприклад «MacBook»",
    "Ждём устройство…": "Очікуємо на пристрій…",
    "Добавить passkey": "Додати passkey",
    "Пространство «{name}» требует второй фактор. Включите приложение-аутентификатор или добавьте passkey — после этого откроются остальные разделы.": "Простір «{name}» вимагає другий фактор. Увімкніть застосунок-автентифікатор або додайте passkey — після цього відкриються інші розділи.",
    "Безопасность": "Безпека",
    "Двухфакторный вход защищает ключи, домены и команду, даже если пароль утёк.": "Двофакторний вхід захищає ключі, домени й команду, навіть якщо пароль витік.",
    "Приложение-аутентификатор (TOTP)": "Застосунок-автентифікатор (TOTP)",
    "Google Authenticator, 1Password, Bitwarden, Яндекс Ключ — любое приложение с кодами на 30 секунд.": "Google Authenticator, 1Password, Bitwarden, Яндекс Ключ — будь-який застосунок із кодами на 30 секунд.",
    "включён": "увімкнено",
    "выключен": "вимкнено",
    "Включён {when}. Осталось кодов восстановления:": "Увімкнено {when}. Залишилось кодів відновлення:",
    " — пора выпустить новые.": " — час згенерувати нові.",
    "Код из приложения или код восстановления": "Код із застосунку або код відновлення",
    "Новые коды восстановления": "Нові коди відновлення",
    "Выключить": "Вимкнути",
    "Выключить двухфакторный вход? Аккаунт останется защищён только паролем.": "Вимкнути двофакторний вхід? Акаунт лишиться захищеним лише паролем.",
    "Двухфакторный вход выключен": "Двофакторний вхід вимкнено",
    "Включить двухфакторный вход": "Увімкнути двофакторний вхід",
    "QR-код для приложения-аутентификатора": "QR-код для застосунку-автентифікатора",
    "1. Отсканируйте QR-код в приложении. Не получается — введите ключ вручную:": "1. Відскануйте QR-код у застосунку. Не виходить — введіть ключ вручну:",
    "2. Введите шесть цифр из приложения": "2. Введіть шість цифр із застосунку",
    "Подтвердить и включить": "Підтвердити і увімкнути",
    "Двухфакторный вход включён 🛡": "Двофакторний вхід увімкнено 🛡",
    "Сессии и устройства": "Сеанси та пристрої",
    "Завершить все сессии, кроме этой? На других устройствах придётся войти заново.": "Завершити всі сеанси, крім цього? На інших пристроях доведеться увійти знову.",
    "Выйти на других устройствах": "Вийти на інших пристроях",
    "Завершено сессий: {n}": "Завершено сеансів: {n}",
    "Сессия завершена": "Сеанс завершено",
    "Мобильное приложение": "Мобільний застосунок",
    "Браузер": "Браузер",
    "это устройство": "цей пристрій",
    "приложение": "застосунок",
    "браузер": "браузер",
    "· вход {when}": "· вхід {when}",
    "· активность {when}": "· активність {when}",
    "Завершить": "Завершити",
    "Push-уведомления получают:": "Push-сповіщення отримують:",
    "Шаблоны": "Шаблони",
    "Письма, которые код отправляет по алиасу с переменными. Каждое сохранение — новая версия; отправленное письмо помнит свою.": "Листи, які ваш код надсилає за аліасом зі змінними. Кожне збереження — нова версія; надісланий лист пам’ятає свою.",
    "Новый шаблон": "Новий шаблон",
    "Алиас": "Аліас",
    "Тема": "Тема",
    "Переменные": "Змінні",
    "Версия": "Версія",
    "Изменён": "Змінено",
    "Шаблонов пока нет": "Шаблонів поки немає",
    "Создать шаблон": "Створити шаблон",
    "Вынесите вёрстку чеков и кодов из кода: разработчик передаёт только алиас и переменные.": "Винесіть верстку чеків і кодів із коду: розробник передає лише аліас і змінні.",
    "Шаблон создан": "Шаблон створено",
    "Сохранено как версия {v}": "Збережено як версію {v}",
    "Такой алиас уже занят": "Такий аліас вже зайнятий",
    "Удалить шаблон? Отправка по этому алиасу начнёт возвращать 404.": "Видалити шаблон? Надсилання за цим аліасом почне повертати 404.",
    "Все шаблоны": "Усі шаблони",
    "Переменные:": "Змінні:",
    "экранируются,": "екрануються,",
    "вставляются как есть,": "вставляються як є,",
    "вложенные поля.": "вкладені поля.",
    "Сохранить версию": "Зберегти версію",
    "Его передаёт код": "Його передає код",
    "Текстовая версия": "Текстова версія",
    "Для почтовых клиентов без HTML и для фильтров спама": "Для поштових клієнтів без HTML і для фільтрів спаму",
    "Предпросмотр": "Попередній перегляд",
    "Текст": "Текст",
    "Тема:": "Тема:",
    "Предпросмотр письма": "Попередній перегляд листа",
    "Нет HTML-версии": "Немає HTML-версії",
    "Нет текстовой версии": "Немає текстової версії",
    "Не хватает переменных:": "Бракує змінних:",
    "API вернёт 422, а не отправит пустоту.": "API поверне 422, а не надішле порожнечу.",
    "Тестовые переменные": "Тестові змінні",
    "Заполнить по шаблону": "Заповнити за шаблоном",
    "Некорректный JSON": "Некоректний JSON",
    "Отправка из кода": "Надсилання з коду",
    "Появятся после сохранения": "З’являться після збереження",
    "Версии": "Версії",
    "Сегменты": "Сегменти",
    "Сохранённые условия: атрибуты, согласие, события за период. Список получателей всегда считается заново — сегмент не «замораживает» людей.": "Збережені умови: атрибути, згода, події за період. Список отримувачів завжди перераховується — сегмент не «заморожує» людей.",
    "Новый сегмент": "Новий сегмент",
    "Сегментов пока нет": "Сегментів ще немає",
    "Например: «тариф pro и оплатил за 30 дней» или «есть согласие и не открывал приложение 60 дней».": "Наприклад: «тариф pro і сплатив за 30 днів» або «є згода і не відкривав застосунок 60 днів».",
    "Сегмент": "Сегмент",
    "Размер": "Розмір",
    "Ревизия": "Ревізія",
    "посчитано {when}": "підраховано {when}",
    "ещё не пересчитывался": "ще не перераховувався",
    "JSON не разбирается": "JSON не розбирається",
    "Сегмент сохранён": "Сегмент збережено",
    "Удалить сегмент «{name}»?": "Видалити сегмент «{name}»?",
    "Это дерево сложнее конструктора (not, фильтры свойств, часы) — правьте его в JSON.": "Це дерево складніше за конструктор (not, фільтри властивостей, години) — редагуйте його в JSON.",
    "Ревизия {rev} · ключ": "Ревізія {rev} · ключ",
    "Покупатели за 30 дней": "Покупці за 30 днів",
    "Ключ": "Ключ",
    "латиница, цифры, - и _": "латиниця, цифри, - і _",
    "Конструктор": "Конструктор",
    "Условия в JSON": "Умови в JSON",
    "Посчитать": "Порахувати",
    "Кто получит маркетинг": "Хто отримає маркетинг",
    "Нажмите «Посчитать»: покажем, сколько контактов подходит и сколько отсеется до отправки — без согласия, отозвавших, подавленных, без адреса.": "Натисніть «Порахувати»: покажемо, скільки контактів підходить і скільки відсіється до відправлення — без згоди, тих, хто відкликав, придушених, без адреси.",
    "получат маркетинг": "отримають маркетинг",
    "из {total}": "з {total}",
    "Подходят под условия": "Підходять під умови",
    "без адреса": "без адреси",
    "в подавлениях": "у придушеннях",
    "отозвали согласие": "відкликали згоду",
    "без согласия": "без згоди",
    "Например:": "Наприклад:",
    "Сегмент может ссылаться на другой сегмент — только на один уровень. Условия проверяются по схеме атрибутов: оператор должен подходить к типу.": "Сегмент може посилатися на інший сегмент — лише на один рівень. Умови перевіряються за схемою атрибутів: оператор має відповідати типу.",
    "без согласия {n}": "без згоди {n}",
    "отозвали {n}": "відкликали {n}",
    "подавлены {n}": "придушено {n}",
    "без адреса {n}": "без адреси {n}",
    "Из {total}{details} → получат маркетинг {eligible}.": "З {total}{details} → отримають маркетинг {eligible}.",
    "все условия": "усі умови",
    "любое условие": "будь-яка умова",
    "Удалить группу": "Видалити групу",
    "Пока ни одного условия.": "Умов ще немає.",
    "и": "і",
    "или": "або",
    "Условие": "Умова",
    "Группа": "Група",
    "Удалить условие": "Видалити умову",
    "Оператор": "Оператор",
    "Значение": "Значення",
    "дней": "днів",
    "от, до": "від, до",
    "через запятую": "через кому",
    "значение": "значення",
    "Вид условия": "Тип умови",
    "Атрибут": "Атрибут",
    "Поле": "Поле",
    "Статус согласия": "Статус згоди",
    "есть согласие на маркетинг": "є згода на маркетинг",
    "согласие отозвано": "згоду відкликано",
    "записи о согласии нет": "запису про згоду немає",
    "Имя события": "Назва події",
    "Сравнение количества": "Порівняння кількості",
    "не менее": "щонайменше",
    "не более": "не більше",
    "ровно": "рівно",
    "Сколько раз": "Скільки разів",
    "раз за": "разів за",
    "всё": "усе",
    "Согласие": "Згода",
    "равно": "дорівнює",
    "не равно": "не дорівнює",
    "одно из": "одне з",
    "ни одно из": "жодне з",
    "больше": "більше",
    "не меньше": "не менше",
    "меньше": "менше",
    "не больше": "не більше",
    "между": "між",
    "содержит": "містить",
    "начинается с": "починається з",
    "заполнено": "заповнено",
    "не заполнено": "не заповнено",
    "за последние N дней": "за останні N днів",
    "больше N дней назад": "більше N днів тому",
    "в ближайшие N дней": "протягом наступних N днів",
    "да": "так",
    "Часовой пояс": "Часовий пояс",
    "Локаль": "Локаль",
    "Дата добавления": "Дата додавання",
    "Статус": "Статус",
    "Политика": "Політика",
    "Уведомления": "Сповіщення",
    "Каждое уведомление — каскад по каналам. «Принято каналом», «Доставлено», «Прочитано» и «Цель» — разные сигналы.": "Кожне сповіщення — каскад за каналами. «Прийнято каналом», «Доставлено», «Прочитано» і «Ціль» — різні сигнали.",
    "Обновить": "Оновити",
    "Тестовая отправка": "Тестове надсилання",
    "все": "усі",
    "все каналы": "усі канали",
    "Канал": "Канал",
    "все политики": "усі політики",
    "Период": "Період",
    "тег: kind=order": "тег: kind=order",
    "Тег (ключ=значение)": "Тег (ключ=значення)",
    "Уведомлений нет": "Сповіщень немає",
    "Отправьте первое через": "Надішліть перше через",
    "или «Тестовую отправку».": "або «Тестове надсилання».",
    "Каскад": "Каскад",
    "Стоимость": "Вартість",
    "код": "код",
    "оценка": "оцінка",
    "Показать ещё": "Показати ще",
    "Уведомление не найдено": "Сповіщення не знайдено",
    "Возможно, оно другого пространства или данные удалены по сроку хранения.": "Можливо, воно з іншого простору або дані видалено за строком зберігання.",
    "Погружение уведомления": "Занурення у сповіщення",
    "политика": "політика",
    "код подтверждения": "код підтвердження",
    "сервисное": "сервісне",
    "контакт": "контакт",
    "Отменить": "Скасувати",
    "Отменить уведомление? Шаги, ещё не переданные поставщику, отменятся; уже переданные не отзываются.": "Скасувати сповіщення? Кроки, ще не передані провайдеру, буде скасовано; вже передані не відкликаються.",
    "Отменено шагов: {n}": "Скасовано кроків: {n}",
    "; уже у поставщика: {k}": "; вже у провайдера: {k}",
    "Все уведомления": "Усі сповіщення",
    "по данным поставщика": "за даними провайдера",
    "часть — оценка": "частина — оцінка",
    "Худший случай": "Найгірший випадок",
    "потолок {max}": "стеля {max}",
    "без потолка": "без стелі",
    "Шагов": "Кроків",
    "успех на шаге {n}": "успіх на кроці {n}",
    "сейчас шаг {n}": "зараз крок {n}",
    "Длительность": "Тривалість",
    "завершено {when}": "завершено {when}",
    "идёт": "триває",
    "Теги:": "Теги:",
    "всё время": "увесь час",
    "24 часа": "24 години",
    "7 дней": "7 днів",
    "30 дней": "30 днів",
    "☀️ Мелководье": "☀️ Мілина",
    "🌑 Глубина": "🌑 Глибина",
  },
};
